import React, { useState, useEffect } from 'react';
import { Table, Button, Input, Modal, Form, Spin, Select, InputNumber, Row, Col, Space } from 'antd';
import { FaRegTrashAlt, FaEdit, FaSearch } from 'react-icons/fa';
import { PlusOutlined } from '@ant-design/icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../api/Api';
import formatarValor from '../formatarValor';

const ProdutoCrud = () => {

const [precoTemp, setPrecoTemp] = useState('0,00');
const [custoTemp, setCustoTemp] = useState('0,00');
const [enableImposto, setEnableImposto] = useState(false);
const [isAddFamiliaVisible, setIsAddFamiliaVisible] = useState(false);
const [isAddUnidadeVisible, setIsAddUnidadeVisible] = useState(false);
const [familiaForm] = Form.useForm();
const [unidadeForm] = Form.useForm();




  // Estados para dados e controle
  const [produtos, setProdutos] = useState([]);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  
  // Formulários
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();
  
  // Estados para seleção
  const [selectedProduto, setSelectedProduto] = useState(null);
  const [produtoToDelete, setProdutoToDelete] = useState(null);
  
  // Estados de loading
  const [tableLoading, setTableLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  
  // Dados relacionados
  const [familias, setFamilias] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [impostos, setImpostos] = useState([]);
  const [isencoes, setIsencoes] = useState([]);
  
  // Estados para cálculos
  const [ivaPercentagem, setIvaPercentagem] = useState(0);
  const [isIsencaoDisabled, setIsencaoDisabled] = useState(true);
  const [isIsencaoRequired, setIsencaoRequired] = useState(false);

  // Função para formatar valor durante a digitação
const formatarValorInput = (value) => {
  // Remove tudo que não for número
  const apenasNumeros = value.replace(/\D/g, '');

  // Converte para número e garante que é inteiro
  const centavos = parseInt(apenasNumeros || '0', 10);

  // Divide por 100 para converter para reais/kwanzas
  const valor = centavos / 100;

  // Formata com separador de milhar e vírgula
  return valor.toLocaleString('pt-AO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};


  // Função para converter valor formatado para número
  const parseValorInput = (value) => {
    return parseFloat(value.replace(/\s/g, '').replace(',', '.')) || 0;
  };

  // Função para calcular preço e atualizar formulário
const calcularPreco = async (formInstance, precoFormatado, custoFormatado) => {
  const preco = parseValorInput(precoFormatado);
  const custo = parseValorInput(custoFormatado);

  const margemAkz = preco - custo;
  const margemPerc = custo > 0 ? (margemAkz * 100) / custo : 0;
  const impostoCalc = (ivaPercentagem / 100) * preco;
  const venda = preco + impostoCalc;


 
  formInstance.setFieldsValue({
   // preco: preco,
    margem_lucro_akz: margemAkz,
    margem_lucro_perc: margemPerc,
    imposto:impostoCalc ,
    precovenda: venda
  });
};



  // Função para calcular custo e atualizar formulário
 
const calcularCusto = async (formInstance, custoFormatado, precoFormatado) => {
  const custo = parseValorInput(custoFormatado);
  const preco = parseValorInput(precoFormatado);

  const margemAkz = preco - custo;
  const margemPerc = custo > 0 ? (margemAkz * 100) / custo : 0;
  const impostoCalc = (ivaPercentagem / 100) * preco;
  const venda = preco + impostoCalc;

  formInstance.setFieldsValue({
   // custo: custo,
    margem_lucro_akz: margemAkz,
    margem_lucro_perc: margemPerc,
    imposto: impostoCalc,
    precovenda: venda
  });
};



  // Configuração do título da página
  useEffect(() => {
    document.title = 'Produtos';
    fetchInitialData();
    fetchEmpresa();
  }, []);

  // Mensagens de feedback
  const showError = (msg) => toast.error(msg);
  const showSuccess = (msg) => toast.success(msg);

  // Buscar dados iniciais
  const fetchInitialData = async () => {
    try {
      setTableLoading(true);
      await Promise.all([fetchProdutos(), fetchRelacionamentos()]);
    } catch (error) {
      showError('Erro ao carregar dados iniciais');
    } finally {
      setTableLoading(false);
    }
  };


const fetchEmpresa = async ()=>{
   const response = await Api.ListEmpresa();


if(response.id_regime==1){
setEnableImposto(true);
}
else{
setEnableImposto(false);
}

  }






  // Buscar produtos
  const fetchProdutos = async () => {
    try {
      const response = await Api.ListProduto();
      const dados = Array.isArray(response) ? response : [];
      
const produtosFormatados = dados.map(item => ({
  key: item.id,
  id: item.id,
  descricao: item.descricao || '',
  preco: item.preco || 0, // <-- use valor bruto
  custo: item.custo || 0,
  precovenda: item.precovenda || 0,
  imposto: item.imposto || 0,
  codbarra: item.codbarra || '',
  codupc: item.codupc || '',
  id_familia: item.id_familia || null,
  id_unidade: item.id_unidade || null,
  id_imposto: item.id_imposto || null,
  id_isencao: item.id_isencao || null,
  familia: item.familia || '',
  unidade: item.unidade || '',
  imposto_descricao: item.imposto_descricao || '',
  isencao: item.isencao || '',
  margem_lucro_perc: item.margem_lucro_perc || 0,
  margem_lucro_akz: item.margem_lucro_akz || 0,
  qtd: item.qtd || 0
}));


      setProdutos(produtosFormatados);
    } catch (error) {
      showError('Erro ao buscar produtos: ' + (error.message || 'Erro desconhecido'));
    }
  };

  // Buscar dados relacionados
  const fetchRelacionamentos = async () => {
    try {
      const [fam, uni, imp, ise] = await Promise.all([
        Api.ListFamilia(),
        Api.ListUnidade(),
        Api.ListImposto(),
        Api.ListIsencao(),
      ]);
      setFamilias(fam || []);
      setUnidades(uni || []);
      setImpostos(imp || []);
      setIsencoes(ise || []);
    } catch (error) {
      showError('Erro ao buscar dados relacionados');
    }
  };
const fetchImpostoInfo = async (id, formInstance) => {
  if (!id) return;

  try {
    const payload = { id };
    const response = await Api.ListImpostoid(payload);

    if (response && response.percentagem !== undefined) {
      const percent = parseFloat(response.percentagem);
      setIvaPercentagem(percent);

      if (id === 1) {
        setIsencaoDisabled(false);
        setIsencaoRequired(true);
      } else {
        setIsencaoDisabled(true);
        setIsencaoRequired(false);
        formInstance.setFieldsValue({ id_isencao: undefined });
      }

      const precoAtual = parseValorInput(precoTemp);  
      const valorImposto = (percent / 100) * precoAtual;
      const precoVenda = precoAtual + valorImposto;

      formInstance.setFieldsValue({
        imposto: valorImposto,
        precovenda: precoVenda
      });


 

    }
  } catch (error) {
    showError('Erro ao buscar imposto: ' + (error.message || 'Erro desconhecido'));
  }
};


  // Manipuladores de CRUD
  const handleAdd = async (values) => {
  setAddLoading(true);
  try {


   const _preco= parseValorInput(precoTemp);
   const _custo= parseValorInput(custoTemp);

if(_custo>_preco)
{
toast.error('O Custo não pode ser maior que o Preço');
return;
}

if(_preco<=0){
toast.error('O Preço não pode ser 0');
return;
}



    const valoresParaEnviar = {
      ...values,
      preco: parseValorInput(precoTemp),
      custo: parseValorInput(custoTemp)
    };
    
    const result = await Api.AddProduto(valoresParaEnviar);
    if (result.success) {
      showSuccess('Produto adicionado com sucesso!');
      setIsAddModalVisible(false);
      form.resetFields();
      setIvaPercentagem(0);
      await fetchProdutos();
    } else {
      showError(result.message);
    }
  } catch (error) {
    showError('Erro ao adicionar produto: ' + error.message);
  } finally {
    setAddLoading(false);
  }
};


   const handleEdit = async (values) => {
  setEditLoading(true);
  try {
    const valoresParaEnviar = {
      ...values,
      preco: parseValorInput(precoTemp),
      custo: parseValorInput(custoTemp)
    };

    const result = await Api.AlterProduto({ id: selectedProduto.id, ...valoresParaEnviar });
    if (result.success) {
      showSuccess('Produto atualizado com sucesso!');
      setIsEditModalVisible(false);
      editForm.resetFields();
      setIvaPercentagem(0);
      await fetchProdutos();
    } else {
      showError(result.message);
    }
  } catch (error) {
    showError('Erro ao atualizar produto: ' + error.message);
  } finally {
    setEditLoading(false);
  }
};



const openmodalAdd=()=>{
 setIsAddModalVisible(true);
 setPrecoTemp('0,00');
  setCustoTemp('0,00');
}



  const handleDelete = async () => {
    setDeleteLoading(true);
    try {
      const result = await Api.DeleteProduto({ id: produtoToDelete });
      if (result.success) {
        showSuccess('Produto excluído com sucesso!');
        setIsDeleteModalVisible(false);
        await fetchProdutos();
      } else {
        showError(result.message);
      }
    } catch (error) {
      showError('Erro ao excluir produto: ' + error.message);
    } finally {
      setDeleteLoading(false);
    }
  };

  // Função para abrir modal de edição
  const handleOpenEditModal = (record) => {
    setSelectedProduto(record);


  const precoFormatado = formatarValor(record.preco);
  const custoFormatado = formatarValor(record.custo);

  setPrecoTemp(precoFormatado);
  setCustoTemp(custoFormatado);

    
    // Prepara os valores formatados para exibição
    const valoresFormatados = {
      ...record,
      preco_formatado: formatarValor(record.preco),
      custo_formatado: formatarValor(record.custo)
    };

    setPrecoTemp(formatarValor(record.preco));
    setCustoTemp(formatarValor(record.custo));

    
    editForm.setFieldsValue(valoresFormatados);
    setIsEditModalVisible(true);
    
    if (record.id_imposto === 1) {
      setIsencaoDisabled(false);
      setIsencaoRequired(true);
    } else {
      setIsencaoDisabled(true);
      setIsencaoRequired(false);
    }

    if (record.id_imposto) {
  // Chama API e faz cálculo manual
  Api.ListImpostoid({ id: record.id_imposto })
    .then((response) => {
      if (response && response.percentagem !== undefined) {
        const percent = parseFloat(response.percentagem);
        setIvaPercentagem(percent);

        // Faz cálculo manual com base no IVA retornado
        const preco = parseFloat(String(record.preco).replace(',', '.'));
        const custo = parseFloat(String(record.custo).replace(',', '.'));

        const impostoCalc = (percent / 100) * preco;
        const precoVenda = preco + impostoCalc;

        editForm.setFieldsValue({
          imposto: impostoCalc,
          precovenda: precoVenda,
          margem_lucro_akz: preco - custo,
          margem_lucro_perc: custo > 0 ? ((preco - custo) * 100) / custo : 0,
        });
      }
    })
    .catch((error) => {
      showError('Erro ao buscar imposto: ' + (error.message || 'Erro desconhecido'));
    });
}

   
  };

  // Renderizar campos do formulário
  const renderFormFields = (formInstance, isEdit = false) => (
    <>
      <Form.Item name="descricao" label="Descrição" rules={[{ required: true, message: 'Descrição é obrigatória' }]}>
        <Input maxLength={150}/>
      </Form.Item>

      <Row gutter={8}>
        <Col span={12}>
          <Form.Item name="codbarra" label="Código de Barra">
            <Input maxLength={50}/>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="codupc" label="Código UPC/UEN">
            <Input maxLength={50}/>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={8}>
        <Col span={12}>
         <Form.Item
  name="id_familia"
  label="Família"
  rules={[{ required: true, message: 'Selecione uma família' }]}
>
  <Select
    loading={!familias.length}
    dropdownRender={menu => (
      <>
        {menu}
        <div style={{ display: 'flex', justifyContent: 'center', padding: 8 }}>
          <Button
            type="link"
            icon={<PlusOutlined />}
            style={{ color: '#184c9c' }}
            onClick={() => setIsAddFamiliaVisible(true)}
          >
            Nova Família
          </Button>
        </div>
      </>
    )}
  >
    {familias.map(f => (
      <Select.Option key={f.id} value={f.id}>{f.descricao}</Select.Option>
    ))}
  </Select>
</Form.Item>
        </Col>
        <Col span={12}>
         <Form.Item
  name="id_unidade"
  label="Unidade"
  rules={[{ required: true, message: 'Selecione uma unidade' }]}
>
  <Select
    loading={!unidades.length}
    dropdownRender={menu => (
      <>
        {menu}
        <div style={{ display: 'flex', justifyContent: 'center', padding: 8 }}>
          <Button
            type="link"
            icon={<PlusOutlined />}
            style={{ color: '#184c9c' }}
            onClick={() => setIsAddUnidadeVisible(true)}
          >
            Nova Unidade
          </Button>
        </div>
      </>
    )}
  >
    {unidades.map(u => (
      <Select.Option key={u.id} value={u.id}>{u.descricao}</Select.Option>
    ))}
  </Select>
</Form.Item>
        </Col>
      </Row>

      <Row gutter={8}>
        <Col span={12}>
         <Form.Item
  name="id_imposto"
  label="Imposto"
  rules={enableImposto ? [{ required: true, message: 'Selecione um imposto' }] : []}
>
  <Select
    disabled={!enableImposto}
    onChange={(id) => {
      fetchImpostoInfo(id, formInstance);

      // Regra opcional: isenção depende do imposto ser 1
      if (id === 1) {
        setIsencaoDisabled(false);
        setIsencaoRequired(true);
      } else {
        setIsencaoDisabled(true);
        setIsencaoRequired(false);
        formInstance.setFieldsValue({ id_isencao: undefined });
      }
    }}
    loading={!impostos.length}
  >
    {impostos.map(i => (
      <Select.Option key={i.id} value={i.id}>{i.descricao}</Select.Option>
    ))}
  </Select>
</Form.Item>

        </Col>
        <Col span={12}>
          <Form.Item label="Percentagem Imposto">
            <Input value={ivaPercentagem} readOnly suffix="%" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        name="id_isencao"
        label="Motivo de Isenção"
        rules={isIsencaoRequired ? [{ required: true, message: 'Selecione o motivo de isenção' }] : []}
      >
        <Select disabled={isIsencaoDisabled} loading={!isencoes.length}>
          {isencoes.map(i => (
            <Select.Option key={i.id} value={i.id}>{i.motivo}</Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Row gutter={8}>
        <Col span={12}>
           <Form.Item 
  label="Preço" 
  required 
  validateStatus={!precoTemp ? 'error' : 'success'} 
  help={!precoTemp ? 'Campo obrigatório' : ''}
>
  <Input
  Input  maxLength={20}
    value={precoTemp}
    onChange={(e) => {
      const valorFormatado = formatarValorInput(e.target.value);
      setPrecoTemp(valorFormatado);
        calcularPreco(formInstance, valorFormatado, custoTemp);

    }}
  // Remove esse onBlur, ou deixe vazio
onBlur={() => {}}

  />
</Form.Item>
<Form.Item name="preco" hidden><Input /></Form.Item>

         
        </Col>
        <Col span={12}>
          <Form.Item 
  label="Custo" 
  required 
  validateStatus={!custoTemp ? 'error' : 'success'} 
  help={!custoTemp ? 'Campo obrigatório' : ''}
>
  <Input
   maxLength={20}
    value={custoTemp}
    onChange={(e) => {
      const valorFormatado = formatarValorInput(e.target.value);
      setCustoTemp(valorFormatado);
  calcularCusto(formInstance, valorFormatado, precoTemp);
    }}
  // Remove esse onBlur, ou deixe vazio
onBlur={() => {}}

  />
</Form.Item>
<Form.Item name="custo" hidden><Input /></Form.Item>

        </Col>
      </Row>

      <Row gutter={8}>
        <Col span={12}>
          <Form.Item name="precovenda" label="Preço Venda">
            <InputNumber
              readOnly
              style={{ width: '100%' }}
              formatter={(value) => formatarValor(value)}
              parser={(value) => value.replace(/\s/g, '').replace(',', '.')}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="imposto" label="Valor Imposto">
            <InputNumber
              readOnly
              style={{ width: '100%' }}
              formatter={(value) => formatarValor(value)}
              parser={(value) => value.replace(/\s/g, '').replace(',', '.')}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={8}>
        <Col span={12}>
          <Form.Item name="margem_lucro_perc" label="Margem de Lucro %">
            <InputNumber
              readOnly
              style={{ width: '100%' }}
              formatter={value => `${formatarValor(value)} %`}
              parser={value => value.replace(/\s/g, '').replace(',', '.').replace('%', '')}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="margem_lucro_akz" label="Margem de Lucro AKZ">
            <InputNumber
              readOnly
              style={{ width: '100%' }}
              formatter={(value) => formatarValor(value)}
              parser={(value) => value.replace(/\s/g, '').replace(',', '.')}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );

  // Configuração das colunas da tabela com filtros
  const columns = [
    {
      title: 'Descrição',
      dataIndex: 'descricao',
      key: 'descricao',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Pesquisar descrição"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: 90 }}
            >
              Pesquisar
            </Button>
            <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
              Limpar
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => <FaSearch style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) =>
        record.descricao.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Preço',
      dataIndex: 'preco',
      key: 'preco',
       render: (value) => formatarValor(value),
    },
    {
      title: 'Custo',
      dataIndex: 'custo',
      key: 'custo',
       render: (value) => formatarValor(value),
    },
    {
      title: 'Preço Venda',
      dataIndex: 'precovenda',
      key: 'precovenda',
       render: (value) => formatarValor(value),
    },
    {
      title: 'Imposto',
      dataIndex: 'imposto',
      key: 'imposto',
       render: (value) => formatarValor(value),
    },
     {
      title: 'Qtd',
      dataIndex: 'qtd',
      key: 'qtd',
       render: (value) => Number(value).toFixed(0),
    },
    {
      title: 'Ações',
      key: 'acoes',
      render: (_, record) => (
        <Space size="middle">
          <FaEdit
            style={{ cursor: 'pointer', color: '#1890ff' }}
            onClick={() => handleOpenEditModal(record)}
            loading={editLoading}
          />
          <FaRegTrashAlt
            style={{ cursor: 'pointer', color: '#ff4d4f' }}
            onClick={() => {
              setProdutoToDelete(record.id);
              setIsDeleteModalVisible(true);
            }}
            loading={deleteLoading}
          />
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <ToastContainer position="top-right" autoClose={5000} />

      {/* Barra de ferramentas */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <Button 
          type="primary" 
          icon={<PlusOutlined />} 
          onClick={() =>openmodalAdd()}
        >
          Adicionar
        </Button>
      </div>

      {/* Tabela de produtos */}
      <Spin spinning={tableLoading} tip="Carregando produtos...">
        <Table 
          columns={columns} 
          dataSource={produtos} 
          rowKey="id" 
            pagination={{ 
              pageSize: 13,
              showSizeChanger: true,
              showQuickJumper: true,
              showTotal: (total, range) => 
                `${range[0]}-${range[1]} de ${total} itens`
            }}
          scroll={{ x: 'max-content' }}
          locale={{
            emptyText: 'Nenhum produto cadastrado'
          }}
        />
      </Spin>

      {/* Modal de Adição */}
      <Modal
        title="Adicionar Novo Produto"
        open={isAddModalVisible}
        onCancel={() => {
          form.resetFields();
          setIvaPercentagem(0);
          setIsAddModalVisible(false);
        }}
        footer={[
          <Button key="cancel" onClick={() => {
            form.resetFields();
            setIvaPercentagem(0);
            setIsAddModalVisible(false);
          }}>
            Cancelar
          </Button>,
          <Button 
            key="submit" 
            type="primary" 
            loading={addLoading}
            onClick={() => form.submit()}
          >
            Salvar
          </Button>
        ]}
        destroyOnClose
      >
        <Form form={form} layout="vertical" onFinish={handleAdd}>
          {renderFormFields(form)}
        </Form>
      </Modal>

      {/* Modal de Edição */}
      <Modal
        title={`Editar Produto - ${selectedProduto?.descricao || ''}`}
        open={isEditModalVisible}
        onCancel={() => {
          editForm.resetFields();
          setIvaPercentagem(0);
          setIsEditModalVisible(false);
        }}
        footer={[
          <Button key="cancel" onClick={() => {
            editForm.resetFields();
            setIvaPercentagem(0);
            setIsEditModalVisible(false);
          }}>
            Cancelar
          </Button>,
          <Button 
            key="submit" 
            type="primary" 
            loading={editLoading}
            onClick={() => editForm.submit()}
          >
            Atualizar
          </Button>
        ]}
        destroyOnClose
      >
        <Form form={editForm} layout="vertical" onFinish={handleEdit}>
          {renderFormFields(editForm, true)}
        </Form>
      </Modal>

      {/* Modal de Exclusão */}
      <Modal
        title="Confirmar Exclusão"
        open={isDeleteModalVisible}
        onOk={handleDelete}
        onCancel={() => setIsDeleteModalVisible(false)}
        okText="Confirmar"
        cancelText="Cancelar"
        confirmLoading={deleteLoading}
      >
        <p>Tem certeza que deseja excluir este produto? Esta ação não pode ser desfeita.</p>
      </Modal>


{/* Modal Adicionar Família */}
<Modal
  title="Adicionar Família"
  open={isAddFamiliaVisible}
  onCancel={() => {
    setIsAddFamiliaVisible(false);
    familiaForm.resetFields();
  }}
  footer={null}
  destroyOnClose
>
  <Form form={familiaForm} layout="vertical" onFinish={async (values) => {
    try {
      const result = await Api.AddFamilia(values); // Crie esse método no seu `Api.js`
      if (result.success) {
        toast.success('Família adicionada com sucesso!');
        await fetchRelacionamentos(); // atualiza a lista
        setIsAddFamiliaVisible(false);
        familiaForm.resetFields();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      toast.error('Erro ao adicionar família');
    }
  }}>
    <Form.Item
      name="descricao"
      label="Descrição"
      rules={[{ required: true, message: 'Descrição é obrigatória' }]}
    >
      <Input maxLength={50} />
    </Form.Item>
    <Form.Item>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={() => {
          familiaForm.resetFields();
          setIsAddFamiliaVisible(false);
        }}>Cancelar</Button>
        <Button type="primary" htmlType="submit" style={{ marginLeft: 8 }}>
          Salvar
        </Button>
      </div>
    </Form.Item>
  </Form>
</Modal>

{/* Modal Adicionar Unidade */}
<Modal
  title="Adicionar Unidade"
  open={isAddUnidadeVisible}
  onCancel={() => {
    setIsAddUnidadeVisible(false);
    unidadeForm.resetFields();
  }}
  footer={null}
  destroyOnClose
>
  <Form form={unidadeForm} layout="vertical" onFinish={async (values) => {
    try {
      const result = await Api.AddUnidade(values); // Crie esse método no seu `Api.js`
      if (result.success) {
        toast.success('Unidade adicionada com sucesso!');
        await fetchRelacionamentos(); // atualiza a lista
        setIsAddUnidadeVisible(false);
        unidadeForm.resetFields();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      toast.error('Erro ao adicionar unidade');
    }
  }}>
    <Form.Item
      name="descricao"
      label="Descrição"
      rules={[{ required: true, message: 'Descrição é obrigatória' }]}
    >
      <Input maxLength={50} />
    </Form.Item>
    <Form.Item>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={() => {
          unidadeForm.resetFields();
          setIsAddUnidadeVisible(false);
        }}>Cancelar</Button>
        <Button type="primary" htmlType="submit" style={{ marginLeft: 8 }}>
          Salvar
        </Button>
      </div>
    </Form.Item>
  </Form>
</Modal>




    </div>
  );
};

export default ProdutoCrud;